import Chevron from './Chevron';

export const IconSvg = { Chevron };
